import React, { Fragment } from 'react'
import Modal from '../Modal/Modal'

const NotVioModal = ({ item_name, onClose, onConfirm }) => {

    return (
        <Modal
            children={<Fragment>
                <h2>Approve Creator</h2>
                <p>Are you sure you want to mark {item_name} as not violating ?</p>
            </Fragment>}
            footer={<Fragment>
                <div >
                    <button onClick={onConfirm} className="confirm-btn">Confirm</button>
                    <button onClick={onClose} className="cancel-btn">Cancel</button>
                </div>
            </Fragment>}

        />)
}

export default NotVioModal